/* eslint-disable no-undef */
import React from 'react'
import {connect} from "react-redux";
import { ArrowRightOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Input, Modal } from 'antd';
import {axios_} from "../../tools/axios_";
import {LoginAction} from "./actions"
import {Patterns} from "../../tools/patterns";
import './jdLogin.less'
import img_JD from "./img/jd_login.svg"
import img_account from "./img/account_v2.png"
import login_title from "./img/login_title.svg"
import ForgetPassword from "./fogetPwd"
import './geetest'
import encrypt from '../../tools/encrypt'
import {hasToken, setLoginUrlCache, setPlatformTokenInfo, Utils} from "../../tools/utils";
import {requestLogin} from "./common/requestLogin";

/**
 * 新版商户登录页面（登录改造需求）
 * @author  wuchao
 * @data    2018-05-16
 */
class LoginV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",//登录账号
            password: "",//密码
            merchant: "",//商户号
            validateStatus: "",//校验状态,可选：'success' 'warning' 'error' 'validating'
            systemNo: "",//系统号
            merchantAction: '',
            merchantActionLabel: '',
            userNameAction: '',
            userNameActionLabel: '',
            passwordAction: '',
            passwordActionLabel: '',
            captchaAction: '',
            captchaActionLabel: '',
            geetestValidateAction: '',//极验验证码
            geetestValidateActionLabel: '',//极验验证码
            captcha: '',
            isShowF: false,//是否展示忘记密码的弹窗（默认false）
            loading: false,
            isUserValdate: true,//用户名是否合法
            isPasswordValdate: true,//密码状态
            isMerchantValdate: true,//商户是否合法
        }
        /** 极验是否校验完成*/
        this.validateSuccess = false;
        this.captchaObj = null;
    }

    /** 生命周期，组件即将挂载*/
    componentDidMount = () => {
        /** 只要使用该页面，就认为使用者为超级管理员*/
        sessionStorage.setItem("permission", "JingDong");//添加京东标识
        // Utils.insertKefu();
        // this.initGeetestDialog();
    };

    /** 初始化极验sdk*/
    initGeetestDialog = () => {
        axios_({
            url: "getGeetest",
            method: "get",
            params: {
                userid: this.state.username,
                t: (new Date().getTime())
            }
        }).then(res => {
            //初始化
            initGeetest({
                // 以下配置参数来自服务端 SDK
                gt: res.data.gt,
                challenge: res.data.challenge,
                offline: !res.data.success,
                product: "popup", // 产品形式，包括：float，popup
                width: "100%",
            }, captchaObj => {
                this.captchaObj = captchaObj;
                // 这里可以调用验证实例 captchaObj 的实例方法
                this.captchaObj.appendTo("#geest_id"); //将验证按钮插入到宿主页面中captchaBox元素内
                this.captchaObj.onSuccess(() => {//校验成功
                    this.validateSuccess = true;
                    this.checkMerchant(false);//校验后不刷新验证码
                    this.checkUsername(false);//校验后不刷新验证码
                    this.checkPassword(false);//校验后不刷新验证码
                    this.setState({
                        geetestValidateAction: 'success',
                        geetestValidateActionLabel: ''
                    });
                });
                this.captchaObj.onError(() => {//校验失败
                    this.validateSuccess = false;
                })
                this.captchaObj.onClose(function () {
                    // 用户把验证关闭了，这时你可以提示用户需要把验证通过后才能进行后续流程
                })
            })
        });
    };
    /**
     * 检查用户名
     * @param isRefreshGeetest  是否刷新极验验证码，默认刷新
     */
    checkUsername = (isRefreshGeetest=true) => {
        const {
            username,
        } = this.state;
        if (!username) {
            this.setState({
                userNameAction: 'error',
                userNameActionLabel: '用户名不能为空',
                isUserValdate: false
            });
        } else if (!new RegExp(Patterns.pattern_username).test(username)) {
            this.setState({
                userNameAction: 'error',
                userNameActionLabel: '请输入正确的用户名',
                isUserValdate: false
            });
        } else {
            this.setState({
                userNameAction: 'success',
                userNameActionLabel: '',
                isUserValdate: true
            });
        }
    };
    /**
     * 检查密码
     * @param isRefreshGeetest  是否刷新极验验证码，默认刷新
     */
    checkPassword = (isRefreshGeetest=true) => {
        const {
            password,
        } = this.state;
        if (!password) {
            this.setState({
                passwordAction: 'error',
                passwordActionLabel: '密码不能为空',
                isPasswordValdate: false
            });
        } else if (!new RegExp(Patterns.pattern_password).test(password)) {
            this.setState({
                passwordAction: 'error',
                passwordActionLabel: '请输入正确的密码',
                isPasswordValdate: false
            });
        } else {
            this.setState({
                passwordAction: 'success',
                passwordActionLabel: '',
                isPasswordValdate: true
            });
        }

    };
    /** 刷新极验验证码*/
    refreshGeetest = () => {
        if (null !== this.captchaObj) {
            this.captchaObj.reset();//刷新极验的验证码
            this.validateSuccess = false;//设置校验状态为失败
        }
    };

    /**
     * 检查商户号
     * @param isRefreshGeetest  是否刷新极验验证码，默认刷新
     */
    checkMerchant = (isRefreshGeetest = true) => {
        const {
            merchant,
        } = this.state;
        if (!merchant) {
            this.setState({
                merchantAction: 'error',
                merchantActionLabel: '商户号不能为空',
                isMerchantValdate: false
            });
        } else if (!new RegExp(Patterns.pattern_username).test(merchant)) {
            this.setState({
                merchantAction: 'error',
                merchantActionLabel: '请输入正确的商户号',
                isMerchantValdate: false

            });
        } else {
            this.setState({
                merchantAction: 'success',
                merchantActionLabel: '',
                isMerchantValdate: true
            });
        }
    };
    /** 检查用户录入的数据，并且执行登录接口*/
    handleSubmit = () => {
        const {username, password, merchant} = this.state;
        if (!merchant) {
            this.setState({
                merchantAction: 'error',
                merchantActionLabel: '商户号不能为空',
            });
            return;
        }
        if (!username) {
            this.setState({
                userNameAction: 'error',
                userNameActionLabel: '用户名不能为空'
            });
            return;
        }
        if (!password) {
            this.setState({passwordAction: 'error', passwordActionLabel: '密码不能为空'});
            return;
        }
        //季磊要求取消屏蔽admin的账号
        // if (username.trim() == "admin") {
        //     this.setState({
        //         userNameAction: 'error',
        //         userNameActionLabel: '未经授权无法登陆'
        //     });
        //     return;
        // }
        if (!merchant) {
            this.setState({
                merchantAction: 'error',
                merchantActionLabel: '商户号不能为空',
            });
            return;
        }
        if (!this.state.isUserValdate || !this.state.isPasswordValdate || !this.state.isMerchantValdate) {
            return
        }
        this.doLogin()
    };

    doLogin = (result = {}) => {
        this.setState({loading: true});
        requestLogin(this).then(res => {
            if (res.data.status === 200) {
                const _token =res.data.tokenInfo.token_type + res.data.tokenInfo.access_token;
                let {access_token, token_type, refresh_token, expires_in}=res.data.tokenInfo;
                const _tokenInfo = {
                  access_token,
                  token_type,
                  refresh_token,
                  expires_in,
                  loginWay:'oldLogin',
                  nowTime:Date.parse(new Date()) / 1000
                };
                setPlatformTokenInfo(JSON.stringify(_tokenInfo));
                setLoginUrlCache();//缓存登陆url
                this.props.setToken(_token);
                this.props.history.replace({pathname: '/homePage'})
            }else {//其他情况
              this.setState({
                merchantAction: 'error',
                userNameAction: 'error',
                passwordAction: 'error',
                captchaAction: 'error',
                merchantActionLabel: res.data.message,
                captchaActionLabel: res.data.message,
                loading: false,
              });
            }

        }).catch(e => {
            this.setState({loading: false});
        })
    };

    render() {
        return (
            <div className="jd_login_div">
                <div className="loginv2_content_div">
                    <div className="jd_login_content">
                        <img className="jd_logo_img" src={img_JD} alt=""/>
                        <div className="login_right_div">
                            <div className="login_name_div">
                                <img src={img_account} alt=""/>
                                <p>登录</p>
                            </div>
                            <Form onKeyDown={e => {
                                e.keyCode === 13 && this.handleSubmit();//enter事件
                            }}>
                                <div className="login_input_div">
                                    <Form.Item
                                        hasFeedback
                                        validateStatus={this.state.merchantAction}
                                        help={this.state.merchantActionLabel}
                                    >
                                        <Input
                                            placeholder="请输入商户号"
                                            size="large"
                                            prefix={<i className="iconfont" style={{color: 'rgba(0,0,0,.25)'}}>&#xe60d;</i>}
                                            value={this.state.merchant}
                                            onBlur={this.checkMerchant}
                                            name="merchant"
                                            onChange={e => {
                                                this.setState({merchant: e.target.value})
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        hasFeedback
                                        validateStatus={this.state.userNameAction}
                                        help={this.state.userNameActionLabel}
                                    >
                                        <Input
                                            placeholder="请输入用户名"
                                            size="large"
                                            prefix={<i className="iconfont" style={{color: 'rgba(0,0,0,.25)'}}>&#xe60e;</i>}
                                            value={this.state.username}
                                            onBlur={this.checkUsername}
                                            type="text"
                                            name="user"
                                            onChange={e => {
                                                this.setState({username: e.target.value})
                                            }}
                                        />
                                    </Form.Item>

                                    <div className="div_password">
                                        <Form.Item
                                            hasFeedback
                                            validateStatus={this.state.passwordAction}
                                            help={this.state.passwordActionLabel}
                                        >
                                            <Input
                                                placeholder="请输入密码"
                                                prefix={<i className="iconfont"
                                                           style={{color: 'rgba(0,0,0,.25)'}}>&#xe60f;</i>}
                                                size="large"
                                                value={this.state.password}
                                                type="password"
                                                name="password"
                                                onBlur={this.checkPassword}
                                                onChange={e => {
                                                    let value = e.target.value;
                                                    this.setState({password: e.target.value})
                                                }}
                                            />
                                        </Form.Item>

                                        <Button size="large" className="dologin_btn" loading={this.state.loading}
                                                onClick={() => {
                                                    this.handleSubmit();
                                                }}>
                                            <ArrowRightOutlined />
                                        </Button>

                                    </div>

                                    <p className="foget_pwd_p"
                                       style={{marginTop: "10px"}}
                                       onClick={() => {
                                           this.setState({isShowF: true});
                                       }}>忘记密码？</p>
                                    <ForgetPassword
                                        isShowF={this.state.isShowF}
                                        onOk={() => {
                                            this.setState({isShowF: false});
                                        }}
                                        onCancel={() => {
                                            this.setState({isShowF: false});
                                        }}
                                    />
                                </div>
                            </Form>
                        </div>
                    </div>
                    <img className="jd_login_title" src={login_title} alt=""/>
                </div>
                <div className="copy">Copyright&copy; 2017 Lima technology All Rights Reserved.京ICP备12345679号-30</div>
            </div>
        );
    }

}

function MapState(props) {
    return {};
}

const WrappedForm = Form.create()(LoginV2);
export default connect(MapState, {...LoginAction})(WrappedForm)
